/* eslint-disable no-param-reassign */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import { set } from 'lodash-es';
import {
  getPerks,
  getPerkFromId,
} from '@/services/api/perks/perks';
// initial state
const state = {
  perks: [],
  perk: {},
};

// getters
const getters = {
  get: (state) => state.perks,
};

// actions
const actions = {
  clear({ commit }) {
    commit('CLEAR');
  },
  async setPerks({ commit }) {
    const success = await getPerks();
    commit('SET_VALUE', { perks: success.data });
    return success.data;
  },
  async setPerk({ commit }, id) {
    const { data } = await getPerkFromId(id);
    commit('SET_VALUE', { perk: data });
    return data;
  },
  setValue({ commit }, object) {
    commit('SET_VALUE', object);
  },
  setValueWithPath({ commit }, object) {
    commit('SET_VALUE_WITH_PATH', object);
  },
};

// mutations
const mutations = {
  CLEAR(state) {
    state.perk = {};
    state.perks = {};
  },
  SET_VALUE(state, object) {
    const [key] = Object.keys(object);
    state[key] = object[key];
  },
  SET_VALUE_WITH_PATH(state, { value, path }) {
    set(state, path, value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
